import React, { useContext, useState } from 'react';
import Application from '../../../StateContext/Application';
import { Rate } from '../../../../../public/LoginImages/importimages';

const Rates = () => {
  const { GetSteelRates } = useContext(Application);
  const [ratesData, setRatesData] = useState([]);
  const [labourData, setLabourData] = useState([]);
  const [machData, setMachData] = useState([]);
  const [rateallmech, setRateAllMech] = useState([]);
  const [mechbooklet, setMechBooklet] = useState([]);
  const [pindex, setPindex] = useState([]);
  const [getcsr, setGetCsr] = useState([]);
  const [showTable, setShowTable] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;

  const fetchData = async () => {
    try {
      const data = await GetSteelRates();
      setRatesData(data.steel_rates || []);
      setLabourData(data.labour_rates || []);
      setMachData(data.wksp_mach_rates || []);
      setRateAllMech(data.rate_allied_machinary || []);
      setMechBooklet(data.machinery_rate_booklet || []);
      setPindex(data.pindex_calculation || []);
      setGetCsr(data.gate_rates_csr || []);
    } catch (error) {
      console.error("Error fetching rates:", error);
    }
  };

  const handleClick = async (type) => {
    if (showTable !== type) {
      if (
        !ratesData.length || !labourData.length || !machData.length ||
        !rateallmech.length || !mechbooklet.length || !pindex.length || !getcsr.length
      ) {
        await fetchData();
      }
      setShowTable(type);
      setCurrentPage(1);
    } else {
      setShowTable("");
    }
  };

  const selectedData = showTable === "steel" ? ratesData
    : showTable === "labour" ? labourData
    : showTable === "mach" ? machData
    : showTable === "rateallmech" ? rateallmech
    : showTable === "booklet" ? mechbooklet
    : showTable === "priceindex" ? pindex
    : showTable === "getrates" ? getcsr
    : [];

  const totalPages = Math.ceil(selectedData.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = selectedData.slice(indexOfFirstBill, indexOfLastBill);

  const renderTableHead = () => {
    switch (showTable) {
      case "steel":
        return (
          <tr>
            <th>Sr.no.</th>
            <th>Item</th>
            <th>Rate (Excl. GST)</th>
            <th>Average</th>
          </tr>
        );
      case "labour":
        return (
          <tr>
            <th>Sr.no.</th>
            <th>Position</th>
            <th>Type</th>
            <th>Equivalent Position</th>
            <th>Daily Salary Rates</th>
          </tr>
        );
      case "mach":
        return (
          <tr>
            <th>Sr.no.</th>
            <th>Machine Type</th>
            <th>Type of Machine Used</th>
            <th>Sanct Rate Hrs 2021</th>
            <th>PI Jun 22</th>
            <th>Rate 23-24 No GST</th>
          </tr>
        );
      case "rateallmech":
        return (
          <tr>
            <th>Sr. No.</th>
            <th>Type of M/c used</th>
            <th>Approved Rates (June 2021)</th>
            <th>Price Index (June 2022)</th>
            <th>2023-24 Rate (No GST)</th>
          </tr>
        );
      case "booklet":
        return (
          <tr>
            <th>Sr. No.</th>
            <th>Machinery Use Rate (2022-2023)</th>
            <th>Rate Per Hr (Rs)</th>
          </tr>
        );
      case "priceindex":
        return (
          <tr>
            <th>Sr. No</th>
            <th>Item</th>
            <th>September 2021</th>
            <th>June 2022</th>
            <th>% Change</th>
          </tr>
        );
      case "getrates":
        return (
          <tr>
            <th>Sr. No</th>
            <th>Description</th>
            <th>Type</th>
            <th>Unit</th>
            <th>Rate 21-22 (No GST)</th>
            <th>Price Index (June 2022)</th>
            <th>Rate 23-24 (No GST)</th>
            <th>Rate 23-24 (with GST)</th>
          </tr>
        );
      default:
        return null;
    }
  };

  const renderTableBody = () => {
    return currentBills.map((row, index) => (
      <tr key={index} style={{
        backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#b799904d',textAlign: 'center',hight: '2rem',}}>
        <td style={{ textAlign: 'center',height:'2rem' }}>{indexOfFirstBill + index + 1}</td>
        {showTable === "steel" && (
          <>
            <td>{row.Item}</td>
            <td>{row.RateExclusiveofGST}</td>
            <td>{row.Average}</td>
          </>
        )}
        {showTable === "labour" && (
          <>
            <td>{row.position}</td>
            <td>{row.type}</td>
            <td>{row.equivalent_position}</td>
            <td>{row.daileysaleryrates}</td>
          </>
        )}
        {showTable === "mach" && (
          <>
            <td>{row.MachineType}</td>
            <td>{row.TypeofM_cused}</td>
            <td>{row.SanctRateHrs2021}</td>
            <td>{row.PI_Jun22}</td>
            <td>{row.Rate2324_NoGST}</td>
          </>
        )}
        {showTable === "rateallmech" && (
          <>
            <td>{row.Type_of_Mc_used}</td>
            <td>{row.app_rates_june2021}</td>
            <td>{row.p_ind_june2022}</td>
            <td>{row.rate_2324_nogst}</td>
          </>
        )}
        {showTable === "booklet" && (
          <>
            <td>{row.mach_use_rates}</td>
            <td>{row.rate_hrs}</td>
          </>
        )}
        {showTable === "priceindex" && (
          <>
            <td>{row.Item}</td>
            <td>{row.sept21}</td>
            <td>{row.june22}</td>
            <td>{row.change}</td>
          </>
        )}
        {showTable === "getrates" && (
          <>
            <td>{row.Description}</td>
            <td>{row.type}</td>
            <td>{row.Unit}</td>
            <td>{row.srate_21_22noGST}</td>
            <td>{row.price22}</td>
            <td>{row.rate23_24noGST}</td>
            <td>{row.rate23_24}</td>
          </>
        )}
      </tr>
    ));
  };

  return (
    <div style={{ backgroundColor: 'aliceblue', padding: '10px' }}>
      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{ width: '16rem' }}>
          <div className="card" style={{ width: "15rem",boxShadow:'0px 0px 2px',backgroundColor:'#98e0ff',padding:'0px 20px 20px 20px'}}>
            <div style={{
              display: 'flex',justifyContent:'space-between', padding: "8px 5px"
            }}>
              <p style={{ color: "black",fontWeight:'600',fontSize:'18px' }}>Rates</p>
              <img src={Rate} style={{height:'4rem',width:'30px'}}/>
            </div>
            <ul className="list-group list-group-flush" style={{ paddingTop:'2px', listStyleType: "none",border:"none" }}>
              {["steel", "labour", "mach", "rateallmech", "booklet", "priceindex", "getrates"].map((type) => (
                <li key={type}>
                  <button
                    onClick={() => handleClick(type)}
                    style={{
                      display:'flex',
                      justifyContent:'start',
                      border: 'none',
                      width: '100%',
                      padding: "5px",
                      background: showTable === type 
                      ? '#f15a24': '#0098d5',
                      color:'white',
                      border: "none",
                      marginBottom: '10px',
                      fontWeight: "500",
                      fontSize: '15px'
                    }}
                  >
                    {type === "steel" && "Steel Rates"}
                    {type === "labour" && "Labour Rates"}
                    {type === "mach" && "Machine Rates"}
                    {type === "rateallmech" && "Rate Allied Mech"}
                    {type === "booklet" && "Mech Use 23-24"}
                    {type === "priceindex" && "Price Index Calculation"}
                    {type === "getrates" && "Gate Material CSR 23-24"}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {showTable && (
          <div style={{ padding: '50px 20px', backgroundColor: '#f4f7fe', flex: 1 }}>
             <h4 style={{ textAlign: 'start', marginBottom: '15px', color: '#f15a24' }}>
              {showTable === "steel" && "Steel Rates"}
              {showTable === "labour" && "Labour Rates"}
              {showTable === "mach" && "Machine Rates"}
              {showTable === "rateallmech" && "Rate Allied Machinery"}
              {showTable === "booklet" && "Machinery Use Rate (2022-2023)"}
              {showTable === "priceindex" && "Price Index Calculation"}
              {showTable === "getrates" && "Gate Material CSR 23-24"}
            </h4>
            <div style={{
              boxShadow: '0px 0px 10px',
              borderRadius: '15px',
              overflowX: 'auto',
              backgroundColor: 'white'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                minWidth: '800px'
              }}>
                <thead style={{background: 'linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)', color: 'black', height: '3rem' }}>
                  {renderTableHead()}
                </thead>
                <tbody>
                  {renderTableBody()}
                </tbody>
              </table>
            </div>

            <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginTop: '20px' }}>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{display:'flex',alignItems:'center',
                  padding: '8px 15px',
                  marginRight: '10px',
                  borderRadius: '5px',
                  backgroundColor: currentPage === 1 ? '#ccc' : 'blue',
                  color: 'white',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                }}
              >
                <span style={{ fontSize: '12px' }}>&lt;</span> Previous
              </button>
              <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{display:'flex',alignItems:'center',
                  padding: '8px 15px',
                  marginLeft: '10px',
                  borderRadius: '5px',
                  backgroundColor: currentPage === totalPages ? '#ccc' : 'blue',
                  color: 'white',
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                }}
              >
                Next <span style={{ fontSize: '15px' }}>&gt;</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Rates;
